import { slideToggle } from "@roghz/slidetoggle";

const mediaQuery = window.matchMedia("(max-width: 1023px)");

const tabs = document.querySelectorAll(".td-tabs");

tabs?.forEach((tabs) => {
    const btn = tabs.querySelector(".tabs-current");
    const list = tabs.querySelector(".tabs-list");
    if (!btn || !list) return;
    const links = list.querySelectorAll("li");
    const content = tabs.querySelectorAll(".tabs-content .tab");
    const isScroll = tabs.classList.contains("is-scroll");
    const isDropDown = tabs.classList.contains("is-dropdown");

    links[0].classList.add("active");
    content[0].classList.add("active");
    btn.textContent = links[0].textContent;

    btn.addEventListener("click", () => {
        slideToggle(list, 500);
        btn.classList.toggle("active");
    });

    links.forEach((link, i) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            links.forEach((l) => l.classList.remove("active"));
            link.classList.add("active");

            if (mediaQuery.matches || isDropDown) {
                slideToggle(list, 500);
                btn.classList.toggle("active");
            }

            if (!isScroll) {
                content.forEach((c) => c.classList.remove("active"));
                content[i].classList.add("active");
                btn.textContent = link.textContent;
            } else {
                const offset = -120;
                const y = content[i].getBoundingClientRect().top + window.pageYOffset + offset;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        });
    });

    if (isScroll) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const idx = [...content].indexOf(entry.target);
                    links.forEach((l) => l.classList.remove("active"));
                    links[idx].classList.add("active");
                    btn.textContent = links[idx].textContent;
                }
            });
        }, {
            rootMargin: "-50% 0px -50% 0px",
            threshold: 0
        });

        content.forEach((c) => observer.observe(c));
    }
});
